const _excluded = ["analyticsName", "contact"],
  _excluded2 = ["contact", "onClick"];
function cov_1tnef5p8dh() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/buy/SupportCard/SupportCard.tsx";
  var hash = "5e32c54897ea007f8ce928df386127204693a2ac";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/buy/SupportCard/SupportCard.tsx",
    statementMap: {
      "0": {
        start: {
          line: 38,
          column: 69
        },
        end: {
          line: 74,
          column: 1
        }
      },
      "1": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 73,
          column: 4
        }
      },
      "2": {
        start: {
          line: 77,
          column: 73
        },
        end: {
          line: 101,
          column: 1
        }
      },
      "3": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 100,
          column: 9
        }
      },
      "4": {
        start: {
          line: 109,
          column: 45
        },
        end: {
          line: 121,
          column: 1
        }
      },
      "5": {
        start: {
          line: 111,
          column: 2
        },
        end: {
          line: 120,
          column: 4
        }
      },
      "6": {
        start: {
          line: 134,
          column: 56
        },
        end: {
          line: 170,
          column: 1
        }
      },
      "7": {
        start: {
          line: 139,
          column: 19
        },
        end: {
          line: 141,
          column: 12
        }
      },
      "8": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 74
        }
      },
      "9": {
        start: {
          line: 140,
          column: 52
        },
        end: {
          line: 140,
          column: 68
        }
      },
      "10": {
        start: {
          line: 143,
          column: 2
        },
        end: {
          line: 169,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 38,
            column: 69
          },
          end: {
            line: 38,
            column: 70
          }
        },
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 74,
            column: 1
          }
        },
        line: 42
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 77,
            column: 73
          },
          end: {
            line: 77,
            column: 74
          }
        },
        loc: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 100,
            column: 9
          }
        },
        line: 83
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 109,
            column: 45
          },
          end: {
            line: 109,
            column: 46
          }
        },
        loc: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 120,
            column: 4
          }
        },
        line: 111
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 134,
            column: 56
          },
          end: {
            line: 134,
            column: 57
          }
        },
        loc: {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 170,
            column: 1
          }
        },
        line: 137
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 139,
            column: 41
          },
          end: {
            line: 139,
            column: 42
          }
        },
        loc: {
          start: {
            line: 139,
            column: 47
          },
          end: {
            line: 141,
            column: 3
          }
        },
        line: 139
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 140,
            column: 34
          },
          end: {
            line: 140,
            column: 35
          }
        },
        loc: {
          start: {
            line: 140,
            column: 52
          },
          end: {
            line: 140,
            column: 68
          }
        },
        line: 140
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 48,
            column: 9
          },
          end: {
            line: 58,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 9
          },
          end: {
            line: 48,
            column: 22
          }
        }, {
          start: {
            line: 49,
            column: 10
          },
          end: {
            line: 57,
            column: 28
          }
        }],
        line: 48
      },
      "1": {
        loc: {
          start: {
            line: 59,
            column: 9
          },
          end: {
            line: 70,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 9
          },
          end: {
            line: 59,
            column: 28
          }
        }, {
          start: {
            line: 60,
            column: 10
          },
          end: {
            line: 69,
            column: 28
          }
        }],
        line: 59
      },
      "2": {
        loc: {
          start: {
            line: 63,
            column: 16
          },
          end: {
            line: 63,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 16
          },
          end: {
            line: 63,
            column: 29
          }
        }, {
          start: {
            line: 63,
            column: 33
          },
          end: {
            line: 63,
            column: 34
          }
        }],
        line: 63
      },
      "3": {
        loc: {
          start: {
            line: 154,
            column: 20
          },
          end: {
            line: 154,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 154,
            column: 40
          },
          end: {
            line: 154,
            column: 45
          }
        }, {
          start: {
            line: 154,
            column: 48
          },
          end: {
            line: 154,
            column: 54
          }
        }],
        line: 154
      },
      "4": {
        loc: {
          start: {
            line: 161,
            column: 11
          },
          end: {
            line: 165,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 161,
            column: 11
          },
          end: {
            line: 161,
            column: 26
          }
        }, {
          start: {
            line: 161,
            column: 30
          },
          end: {
            line: 161,
            column: 43
          }
        }, {
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 164,
            column: 18
          }
        }],
        line: 161
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5e32c54897ea007f8ce928df386127204693a2ac"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1tnef5p8dh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1tnef5p8dh();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Avatar } from '@opendoor/bricks/complex';
import { Box, Card, Flex, Icon, Link, Text } from '@opendoor/bricks/core';
import { formatValue } from '@opendoor/bricks/core/Input/helpers';

/** Props for the SupportButton component */

/** Props for the SupportCard component */
/** Renders a non-clickable card that displays photo, name, title, license, email, and phone number */
cov_1tnef5p8dh().s[0]++;
export const SupportCard = _ref => {
  let {
      analyticsName,
      contact
    } = _ref,
    marginProps = _objectWithoutProperties(_ref, _excluded);
  cov_1tnef5p8dh().f[0]++;
  cov_1tnef5p8dh().s[1]++;
  return /*#__PURE__*/React.createElement(Card, _extends({
    "data-testid": "support-card",
    variant: "secondary"
  }, marginProps), /*#__PURE__*/React.createElement(Flex, {
    width: "100%",
    alignItems: "baseline",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(BaseSupportInfo, {
    contact: contact,
    type: "card"
  }), /*#__PURE__*/React.createElement(Box, {
    "aria-hidden": true,
    as: "hr",
    my: 7,
    w: "100%",
    opacity: 0.16
  }), (cov_1tnef5p8dh().b[0][0]++, contact.email) && (cov_1tnef5p8dh().b[0][1]++, /*#__PURE__*/React.createElement(SupportCardLink, {
    "data-testid": "support-card-email",
    href: "mailto:".concat(contact.email),
    title: contact.email,
    analyticsName: "".concat(analyticsName, "-email"),
    "aria-label": "Email ".concat(contact.email, " for support")
  }, contact.email)), (cov_1tnef5p8dh().b[1][0]++, contact.phoneNumber) && (cov_1tnef5p8dh().b[1][1]++, /*#__PURE__*/React.createElement(SupportCardLink, {
    "data-testid": "support-card-phone",
    href: "tel:".concat(contact.phoneNumber),
    mt: (cov_1tnef5p8dh().b[2][0]++, contact.email) && (cov_1tnef5p8dh().b[2][1]++, 6),
    title: formatValue(contact.phoneNumber, 'tel', 0),
    analyticsName: "".concat(analyticsName, "-phone-number"),
    "aria-label": "Call ".concat(contact.phoneNumber, " for support")
  }, formatValue(contact.phoneNumber, 'tel', 0)))));
};

/** Renders a clickable button that only displays the photo, name, and title based on support type */
cov_1tnef5p8dh().s[2]++;
export const SupportButton = _ref2 => {
  let {
      contact,
      onClick
    } = _ref2,
    marginProps = _objectWithoutProperties(_ref2, _excluded2);
  cov_1tnef5p8dh().f[1]++;
  cov_1tnef5p8dh().s[3]++;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React.createElement(Card, _extends({
      "data-testid": "support-button",
      as: "button",
      cursor: "pointer",
      variant: "secondary",
      onClick: onClick,
      "aria-label": "".concat(contact.name, ", ").concat(contact.title),
      py: [7, 7, 7],
      px: [5, 5, 5],
      _focus: {
        border: undefined
      },
      _hover: {
        backgroundColor: 'neutrals10'
      }
    }, marginProps), /*#__PURE__*/React.createElement(Flex, {
      width: "100%",
      alignItems: "center",
      flexDirection: "row"
    }, /*#__PURE__*/React.createElement(BaseSupportInfo, {
      contact: contact,
      type: "button"
    }), /*#__PURE__*/React.createElement(Icon, {
      size: 16,
      name: "chevron-right",
      "aria-hidden": "true"
    })))
  );
};

/**
 * Styled link to display contact information
 *
 * Truncates text based on the following pattern:
 * https://css-tricks.com/snippets/css/truncate-string-with-ellipsis/
 */
cov_1tnef5p8dh().s[4]++;
const SupportCardLink = props => {
  cov_1tnef5p8dh().f[2]++;
  cov_1tnef5p8dh().s[5]++;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React.createElement(Link, _extends({
      fontSize: "s0",
      lineHeight: "s000",
      fontWeight: "semibold",
      width: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }, props))
  );
};
/**
 * Component that displays the basic information of a support contact (image, name, and title)
 * If the contact contains a licenseNumber, we show it under the support title if type is 'card'
 */
cov_1tnef5p8dh().s[6]++;
const BaseSupportInfo = _ref3 => {
  let {
    contact: {
      name,
      title,
      photoUrl,
      licenseNumber
    },
    type
  } = _ref3;
  cov_1tnef5p8dh().f[3]++;
  // Initials to use in case photoUrl is undefined
  const initials = (cov_1tnef5p8dh().s[7]++, React.useMemo(() => {
    cov_1tnef5p8dh().f[4]++;
    cov_1tnef5p8dh().s[8]++;
    return name.split(' ').reduce((acc, subname) => {
      cov_1tnef5p8dh().f[5]++;
      cov_1tnef5p8dh().s[9]++;
      return acc + subname[0];
    }, '');
  }, [name]));
  cov_1tnef5p8dh().s[10]++;
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Avatar, {
    mr: 5,
    size: "md",
    src: photoUrl,
    initials: initials,
    alt: "Support ".concat(name)
  }), /*#__PURE__*/React.createElement(Box, {
    textAlign: "start",
    flex: "1",
    mr: "3"
  }, /*#__PURE__*/React.createElement(Text, {
    lineHeight: "100",
    fontWeight: "semibold",
    size: "s1",
    "data-testid": "support-button-name"
  }, name), /*#__PURE__*/React.createElement(Text, {
    mt: 3,
    lineHeight: "s000",
    fontSize: type === 'button' ? (cov_1tnef5p8dh().b[3][0]++, 's00') : (cov_1tnef5p8dh().b[3][1]++, 's000'),
    color: "neutrals90",
    fontWeight: "semibold",
    "data-testid": "support-button-title"
  }, title, " ", /*#__PURE__*/React.createElement("br", null), (cov_1tnef5p8dh().b[4][0]++, type === 'card') && (cov_1tnef5p8dh().b[4][1]++, licenseNumber) && (cov_1tnef5p8dh().b[4][2]++, /*#__PURE__*/React.createElement(Box, {
    as: "span",
    "data-testid": "support-button-license"
  }, "Lic #", licenseNumber)))));
};
//# sourceMappingURL=SupportCard.mjs.map